import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import Checkout from "../components/Checkout";
import { homeActions } from "../store/reducers/home-slice";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const Home = () => {
  const query = useQuery();
  const dispatch = useDispatch();

  const item_id = query.get("item_id"),
    coupon = query.get("coupon"),
    source = query.get("utm_source"),
    medium = query.get("utm_medium"),
    campaign = query.get("utm_campaign"),
    term = query.get("utm_term"),
    stream = query.get("utm_stream"),
    name = query.get("name"),
    email = query.get("email"),
    phone = query.get("phone"),
    firstSource = query.get("fs"),
    firstMedium = query.get("fm"),
    firstCampaign = query.get("fc"),
    firstContent = query.get("fw"),
    firstTerm = query.get("ft"),
    firstReferrer = query.get("fr"),
    firstLandingPage = query.get("fl"),
    firstGclid = query.get("fg"),
    firstFbclid = query.get("ff"),
    firstTimestamp = query.get("fts"),
    lastSource = query.get("ls"),
    lastMedium = query.get("lm"),
    lastCampaign = query.get("lc"),
    lastContent = query.get("lw"),
    lastTerm = query.get("lt"),
    lastReferrer = query.get("lr"),
    lastLandingPage = query.get("ll"),
    lastGclid = query.get("lg"),
    lastFbclid = query.get("lf"),
    lastTimestamp = query.get("lts"),
    stashToken = query.get("stashToken"),
    confirmEmail = query.get("confirmEmail"),
    classStudying = query.get("class"),
    country = query.get("country"),
    state = query.get("state"),
    city = query.get("city"),
    redirectUrl = query.get("redirectUrl"),
    showThankYouPage = query.get("showThankYouPage"),
    screen = query.get("screen"),
    unit = query.get("unit"),
    pack = query.get("pack");

  useEffect(() => {
    dispatch(
      homeActions.initialize({
        item_id,
        coupon,
        utm: { source, medium, campaign, term, stream },
        firstUtmParams: {
          source: firstSource,
          medium: firstMedium,
          campaign: firstCampaign,
          content: firstContent,
          term: firstTerm,
          referrer: firstReferrer,
          landingPage: firstLandingPage,
          gclid: firstGclid,
          fbclid: firstFbclid,
          timestamp: firstTimestamp,
        },
        lastUtmParams: {
          source: lastSource,
          medium: lastMedium,
          campaign: lastCampaign,
          content: lastContent,
          term: lastTerm,
          referrer: lastReferrer,
          landingPage: lastLandingPage,
          gclid: lastGclid,
          fbclid: lastFbclid,
          timestamp: lastTimestamp,
        },
        stashToken,
        user: {
          name,
          email,
          phone,
          confirmEmail,
          redirectUrl,
          showThankYouPage,
          screen,
          unit,
          pack,
          classStudying,
          country,
          state,
          city,
        },
      }),
    );
  }, [
    dispatch,
    campaign,
    coupon,
    email,
    item_id,
    medium,
    name,
    phone,
    confirmEmail,
    classStudying,
    country,
    state,
    city,
    source,
    term,
    stream,
    redirectUrl,
    showThankYouPage,
    screen,
    unit,
    pack,
  ]);

  return <Checkout itemId={item_id} />;
};

export default Home;
